/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defaults } from 'underscore';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import EditFormBreadcrumbs from 'ContentComponents/components/cmv2/EditFormBreadcrumbs';
import { getDisplayName, getHasUndoRedoAccess } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getSelectedModuleName, getSelectedItemInTree, getSelectedItemId, getSelectedModuleSchema, getSelectedModuleBodyAsJSObject, getSelectionIsNestedModuleInRichText, getSelectedGridLayoutNode } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import SidebarHeaderContainer from 'ContentEditorUI/containers/SidebarHeaderContainer';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { getActiveSidebarPanel, getPreviousSidebarPanel, getSelectedField, getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { setDirtyFlag, setIframeLoading } from 'ContentEditorUI/redux/actions/appActions';
import { clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { updateSelectedField } from 'ContentEditorUI/redux/actions/editSidebarActions';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import { fetchPageCssAssets } from 'ContentEditorUI/redux/actions/contentAssetsActions';
import { getPreviewIframeNeedsRefresh } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { openPreviousPanel, closePatagoniaSidebar, setActivePatagoniaPanel } from 'ContentEditorUI/redux/actions/panelActions';
import { getNodeType } from 'ContentEditorUI/utils/layoutSectionTreeUtils';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { selectInstanceValues, selectTableAsModuleSchema } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { isContainerGridAtBreakpoint, isContainerStackAtBreakpoint, getContainerBreakpointLayout } from 'layout-data-lib/GridLayoutDataTree/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  const selectedModuleName = getSelectedModuleName(state);
  return {
    displayName: getDisplayName(state, selectedModuleName),
    activePanel: getActiveSidebarPanel(state),
    hasUndoRedoAccess: getHasUndoRedoAccess(state),
    iframeNeedsRefresh: getPreviewIframeNeedsRefresh(state),
    selectedModuleName,
    selectedGridNode: getSelectedGridLayoutNode(state),
    activeBreakpoint: getActiveBreakpointName(state),
    node: getSelectedItemInTree(state),
    selectedItemId: getSelectedItemId(state),
    previousPanel: getPreviousSidebarPanel(state),
    selectedField: getSelectedField(state),
    selectedModuleSchema: getSelectedModuleSchema(state),
    selectedModuleBodyAsJSObject: getSelectedModuleBodyAsJSObject(state),
    isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state),
    isDataAuthoringModeActive: getIsDataAuthoringModeActive(state),
    instanceValues: selectInstanceValues(state),
    tableAsModuleSchema: selectTableAsModuleSchema(state),
    selectionIsNestedModuleInRichText: getSelectionIsNestedModuleInRichText(state)
  };
};
const mapDispatchToProps = {
  setDirtyFlag,
  clearSelectedItem,
  setIframeLoading,
  fetchPageCssAssets,
  openPreviousPanel,
  updateSelectedField,
  closePatagoniaSidebar,
  setActivePanel: setActivePatagoniaPanel
};
class SidebarHeader extends Component {
  constructor(props) {
    super(props);
    this.refreshPreview = this.refreshPreview.bind(this);
    this.onModuleSubmit = this.onModuleSubmit.bind(this);
    this.endEditView = this.endEditView.bind(this);
    this.saveModuleCallback = this.saveModuleCallback.bind(this);
    this.clearSelectedField = this.clearSelectedField.bind(this);
  }
  endEditView(moduleToHighlight) {
    this.props.clearSelectedItem();
    if (moduleToHighlight) {
      this.props.openPreviousPanel();
    }
  }
  onModuleSubmit(opts) {
    const options = defaults(opts, {
      shouldRefreshPreview: true,
      shouldReturnToList: true,
      moduleToHighlight: '',
      shouldResetFocusedWidget: true
    });
    const {
      shouldRefreshPreview,
      moduleToHighlight,
      shouldReturnToList,
      shouldResetFocusedWidget
    } = options;
    this.props.setDirtyFlag(true);
    if (shouldResetFocusedWidget) {
      this.props.clearSelectedItem();
      if (shouldRefreshPreview) {
        return;
      }
    }
    if (shouldRefreshPreview) {
      this.refreshPreview(!shouldResetFocusedWidget && !shouldReturnToList);
    }
    if (shouldReturnToList) {
      this.endEditView(moduleToHighlight);
    }
  }
  saveModuleCallback() {
    const {
      iframeNeedsRefresh,
      selectedItemId,
      isPatagoniaSidebarCollapsed
    } = this.props;
    this.onModuleSubmit({
      moduleToHighlight: selectedItemId,
      shouldRefreshPreview: iframeNeedsRefresh
    });
    if (!isPatagoniaSidebarCollapsed) {
      this.props.closePatagoniaSidebar();
    }
  }
  refreshPreview() {
    const {
      bus,
      saveActions
    } = this.props;
    this.props.setIframeLoading();
    saveActions.autoSave().then(() => {
      this.props.fetchPageCssAssets();
      bus.trigger('preview:refresh');
    });
  }
  clearSelectedField() {
    this.props.updateSelectedField(null);
  }
  getGridNodeDisplayLabel() {
    const {
      selectedGridNode,
      activeBreakpoint
    } = this.props;
    if (!selectedGridNode) {
      return null;
    }
    const isContainerSelected = selectedGridNode.isContainer();
    const isGridContainerSelected = isContainerSelected && isContainerGridAtBreakpoint(selectedGridNode, activeBreakpoint);
    const isStackContainerSelected = isContainerSelected && isContainerStackAtBreakpoint(selectedGridNode, activeBreakpoint);
    if (selectedGridNode.isSection()) {
      return 'editOverlay.gridSection';
    }
    if (isGridContainerSelected) {
      return 'editOverlay.grid';
    }
    if (isStackContainerSelected) {
      const containerLayout = getContainerBreakpointLayout(selectedGridNode, activeBreakpoint);
      if (containerLayout.direction === 'VERTICAL') {
        return 'editOverlay.column';
      } else if (containerLayout.direction === 'HORIZONTAL') {
        return 'editOverlay.row';
      }
    }
    return 'editOverlay.pageStyles';
  }
  renderSidebarHeaderLabel() {
    const {
      displayName,
      activePanel,
      node,
      selectedGridNode
    } = this.props;
    const displayNameToUse = displayName || I18n.text('editOverlay.pageStyles');
    if (activePanel === SIDEBAR_PANELS.edit) {
      if (selectedGridNode && !selectedGridNode.isModule()) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: this.getGridNodeDisplayLabel()
        });
      } else if (displayName) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "editOverlay.header",
          options: {
            displayName: displayNameToUse
          }
        });
      } else {
        const layoutItemType = node && getNodeType(node);
        if (layoutItemType) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.layoutStyles.editStyles-cleanLines-${layoutItemType}`
          });
        }
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "editOverlay.header",
          options: {
            displayName: I18n.text('editOverlay.pageStyles')
          }
        });
      }
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editSidebarHeader"
    });
  }
  returnToRootPatagoniaPanel(panelType) {
    this.props.clearSelectedItem({
      returnToPreviousPanel: true
    });
    this.props.setActivePanel(panelType);
  }
  renderBreadcrumbs() {
    const {
      activePanel,
      previousPanel,
      selectedField,
      selectedModuleSchema,
      selectedModuleBodyAsJSObject,
      isDataAuthoringModeActive,
      selectionIsNestedModuleInRichText
    } = this.props;
    const currentBreadCrumb = activePanel === SIDEBAR_PANELS.edit ? /*#__PURE__*/_jsx(Link, {
      onClick: this.clearSelectedField,
      disabled: !selectedField,
      children: this.renderSidebarHeaderLabel()
    }, "selected-item-name-breadcrumb") : null;
    const homePanel = previousPanel === SIDEBAR_PANELS.optimizer ? SIDEBAR_PANELS.optimizer : SIDEBAR_PANELS.pageContents;
    const homeBreadcrumb = /*#__PURE__*/_jsx(Link, {
      onClick: () => this.returnToRootPatagoniaPanel(homePanel),
      "data-selenium": "save-and-go-to-module-list",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `patagonia.sidebar.tooltipLabel.${homePanel}`
      })
    }, "home-breadcrumb");
    const rootBreadcrumbs = [homeBreadcrumb, currentBreadCrumb];
    if (isDataAuthoringModeActive) {
      const fields = selectionIsNestedModuleInRichText ? selectedModuleSchema.fields : this.props.tableAsModuleSchema.fields;
      const module = selectionIsNestedModuleInRichText ? selectedModuleBodyAsJSObject : this.props.instanceValues;
      return /*#__PURE__*/_jsx(EditFormBreadcrumbs, {
        fieldKey: selectedField,
        fields: fields,
        module: module,
        onKeyChange: this.props.updateSelectedField,
        hideBottomBorder: true,
        rootBreadcrumbs: rootBreadcrumbs,
        paddingBlockStart: "300",
        paddingBlockEnd: "0",
        paddingInlineEnd: "1000"
      });
    }
    return /*#__PURE__*/_jsx(EditFormBreadcrumbs, {
      fieldKey: selectedField,
      fields: selectedModuleSchema ? selectedModuleSchema.fields : null,
      module: selectedModuleBodyAsJSObject,
      onKeyChange: this.props.updateSelectedField,
      hideBottomBorder: true,
      rootBreadcrumbs: rootBreadcrumbs,
      paddingBlockStart: "300",
      paddingBlockEnd: "0",
      paddingInlineEnd: "1000"
    });
  }
  render() {
    const {
      selectedModuleSchema,
      selectedItemId
    } = this.props;
    const {
      SidebarHeaderExtension
    } = EditorConfigSingleton.getComponents();
    if (SidebarHeaderExtension) {
      return /*#__PURE__*/_jsx(SidebarHeaderExtension, {
        breadcrumbs: this.renderBreadcrumbs(),
        headerLabel: this.renderSidebarHeaderLabel(),
        closePatagoniaSidebarCallback: this.saveModuleCallback,
        moduleSchema: selectedModuleSchema,
        selectedModuleId: selectedItemId
      });
    }
    return /*#__PURE__*/_jsx(SidebarHeaderContainer, {
      breadcrumbs: this.renderBreadcrumbs(),
      headerLabel: this.renderSidebarHeaderLabel(),
      closePatagoniaSidebarCallback: this.saveModuleCallback,
      moduleSchema: selectedModuleSchema
    });
  }
}
SidebarHeader.propTypes = {
  displayName: PropTypes.string,
  activePanel: PropTypes.string.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  showDeviceToggle: PropTypes.bool.isRequired,
  setDirtyFlag: PropTypes.func.isRequired,
  setIframeLoading: PropTypes.func.isRequired,
  fetchPageCssAssets: PropTypes.func.isRequired,
  iframeNeedsRefresh: PropTypes.bool.isRequired,
  openPreviousPanel: PropTypes.func.isRequired,
  node: PropTypes.object,
  selectedItemId: PropTypes.string,
  clearSelectedItem: PropTypes.func,
  previousPanel: PropTypes.string.isRequired,
  selectedField: PropTypes.object,
  selectedModuleSchema: PropTypes.object,
  updateSelectedField: PropTypes.func.isRequired,
  selectedModuleBodyAsJSObject: PropTypes.object,
  saveActions: PropTypes.object.isRequired,
  bus: PropTypes.object.isRequired,
  isPatagoniaSidebarCollapsed: PropTypes.bool,
  isDataAuthoringModeActive: PropTypes.bool,
  instanceValues: PropTypes.object,
  tableAsModuleSchema: PropTypes.object,
  closePatagoniaSidebar: PropTypes.func,
  setActivePanel: PropTypes.func,
  selectionIsNestedModuleInRichText: PropTypes.boolean
};
export default connect(mapStateToProps, mapDispatchToProps)(withEditorActionsAndEvents(SidebarHeader));